import React from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import { Project } from '../../domain/Project';
import { ExternalLink, Github, Eye, Layers } from 'lucide-react';

export const ProjectsSection: React.FC = () => {
  const { projects, selectedCategory, setSelectedCategory, setSelectedProject } = usePortfolio();

  const categories = [
    { id: 'all', label: 'All Projects' },
    { id: 'web-app', label: 'Frontend Web Apps' },
    { id: 'full-stack', label: 'Full-Stack Platforms' },
    { id: 'it-infrastructure', label: 'IT & Network Ops' },
    { id: 'cloud-api', label: 'Cloud & APIs' }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <div className="section-title-wrap">
          <div className="section-tag">
            <Layers size={14} />
            <span>Featured Showcase</span>
          </div>
          <h2 className="section-title">
            Crafted <span>Projects & Applications</span>
          </h2>
          <p className="section-subtitle">
            Demonstrating clean object-oriented architecture, modular TypeScript code, and responsive dark glassmorphic design.
          </p>
        </div>

        {/* Category Filter Bar */}
        <div className="projects-filter-bar">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="projects-grid">
          {projects.map((project: Project) => (
            <div key={project.id} className="project-card">
              <div className="project-image-wrap">
                <img
                  src={project.imageUrl}
                  alt={project.title}
                  className="project-image"
                  loading="lazy"
                />
                <span className="project-category-badge">
                  {project.getCategoryLabel()}
                </span>
              </div>

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.shortDescription}</p>

                <div className="project-tags">
                  {project.techStack.map((tech, idx) => (
                    <span key={idx} className="tech-tag">{tech}</span>
                  ))}
                </div>

                <div className="project-footer">
                  <button
                    className="project-link-btn"
                    onClick={() => setSelectedProject(project)}
                    title="View Deep Dive Details"
                  >
                    <Eye size={16} />
                    <span>View Architecture</span>
                  </button>

                  <div style={{ display: 'flex', gap: '0.8rem' }}>
                    {project.githubUrl && (
                      <a
                        href={project.githubUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="project-link-btn"
                        title="GitHub Repository"
                      >
                        <Github size={16} />
                      </a>
                    )}
                    {project.liveDemoUrl && (
                      <a
                        href={project.liveDemoUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="project-link-btn"
                        style={{ color: 'var(--accent-cyan)' }}
                        title="Live Demo"
                      >
                        <ExternalLink size={16} />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
